/**
 * @generated SignedSource<<71fcf805a80c56e475dcfde7b04b98e9>>
 * @relayHash 190f1b392975e554f94f126682b25ee8
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 190f1b392975e554f94f126682b25ee8

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filters"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "filters",
        "variableName": "filters"
      }
    ],
    "kind": "ScalarField",
    "name": "countContracts",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ContractsQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContractsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "190f1b392975e554f94f126682b25ee8",
    "metadata": {},
    "name": "ContractsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

node.hash = "9465b7b10553d4d3fb2e7354c552a01a";

export default node;
